import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import { getProfile, createOrder, viewPolicy, initiatePayment, requestPaymentGateway, createMotorEntry, updateOrderStatus } from "../../../utils/backend";
import { isGatewayCheckoutError, startPaymentCheckoutOnce } from "../../../utils/gatewayCheckout";

import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";
import useGetCarQuoteList from "../../../store/selectors/get-car-quote-list";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import useGetCarAddOnSelection from "../../../store/selectors/get-car-add-on-selection";
import useGetToken from "../../../store/selectors/get-token";
import useGetOrderDetailsId from "../../../store/selectors/get-order-details";
import useGetOrderId from "../../../store/selectors/get-order-id";

import useStoreCarAddOn from "../../../store/actions/store-car-add-on";
import useStoreCarAddOnSelection from "../../../store/actions/store-car-add-on-selection";
import useStoreVehicleInfo from "../../../store/actions/store-vehicle-info";
import useStoreCarQuoteList from "../../../store/actions/store-car-quote-list";
import useStoreCarPlanQuote from "../../../store/actions/store-car-plan-quote";
import { getInsurerName } from "../../../utils/insurer-name";
import UnderwriterDisclosure from "../../../components/UnderwriterDisclosure";
import CommissionRebateNotice from "../../../components/CommissionRebateNotice";
import { useTranslation } from "react-i18next";

const MotorPaymentPage = () => {
	const selectedPlan = useGetCarPlan() || {};
  const carQuoteList = useGetCarQuoteList();
  // [COVER-NOTE FIX] selectedPlan can lose quote_ref_no after a re-quote rebuild; recover the
  // insurer QUOTATION from the get-quote list (which carries it) by insurer_name when blank.
  const resolveQuoteRefNo = (plan) => {
    if (plan && plan.quote_ref_no) return plan.quote_ref_no;
    const list = Array.isArray(carQuoteList) ? carQuoteList : ((carQuoteList && carQuoteList.data) || []);
    const match = list.find((q) => q && plan && q.insurer_name === plan.insurer_name);
    return (match && match.quote_ref_no) || "";
  };
	const vehicleInfo = useGetVehicleInfo();
	const token = useGetToken();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const { t } = useTranslation();

	const defaultDrivers = [{ code: "01", name: vehicleInfo?.owner_name || "THE POLICY HOLDER" }];

	const [drivers, setDrivers] = useState(() => {
		const cachedDrivers = localStorage.getItem("drivers");
		return cachedDrivers ? JSON.parse(cachedDrivers) : [];
	});

	const [adddriver, setAddDriver] = useState(() => {
		const cachedDrivers = localStorage.getItem("adddriver");
		return cachedDrivers ? JSON.parse(cachedDrivers) : [];
	});

	const [allianzadddriver, setAllianzAddDriver] = useState(() => {
		const cachedDrivers = localStorage.getItem("allianz_adddriver");
		return cachedDrivers ? JSON.parse(cachedDrivers) : [];
	});

	const [selectedVariant, setSelectedVariant] = useState(() => {
		const cachedVariant = localStorage.getItem("selectedVariant");
		return cachedVariant ? JSON.parse(cachedVariant) : null;
	});

	const [lonpacCart, setLonpacCart] = useState(() => {
		const cachedCart = localStorage.getItem("cart_selection");
		return cachedCart
			? JSON.parse(cachedCart)
			: {
					name: "CART 7 DAYS @ RM50.00/DAY",
					code: "7x50",
					si: "350",
					sum_insured: "350",
					unit: "7",
					amount: "50",
			  };
	});

	const [etiqaCart, setEtiqaCart] = useState(() => {
		const cachedCart = localStorage.getItem("etiqa_cart_selection");
		return cachedCart ? JSON.parse(cachedCart) : {name: "CART 7 DAYS @ RM50.00/DAY", code: 'P07A'};
	});

	const [etiqaLou, setEtiqaLou] = useState(() => {
		const cachedCart = localStorage.getItem("etiqa_lou_selection");
		return cachedCart ? JSON.parse(cachedCart) : { name: "Loss of Use (LOU) 10 Days x RM50/day", code: "P10A" }});

	const [etiqaD01A, setEtiqaD01A] = useState(() => {
		const cachedCart = localStorage.getItem("etiqa_d01a_selection");
		return cachedCart ? JSON.parse(cachedCart) : { name: "Car Re­-Spray Limit up to RM1,000", code: "D01A" }});

	const getOrderDetailsId = useGetOrderDetailsId();
	const addOnSelection = useGetCarAddOnSelection();
	const orderId = useGetOrderId();

	const [email, setEmail] = useState("");
	const [phone_no, setPhoneNo] = useState("");

	const clearVehicleInfo = useStoreVehicleInfo();
	const clearCarAddOn = useStoreCarAddOn();
	const clearCarAddOnSelection = useStoreCarAddOnSelection();
	const clearCarQuoteList = useStoreCarQuoteList();
	const clearCarPlanQuote = useStoreCarPlanQuote();

	const clearCacheAndState = () => {
		// Clear Redux store
		clearVehicleInfo(null);
		clearCarAddOn(null);
		clearCarAddOnSelection(null);
		clearCarQuoteList(null);
		clearCarPlanQuote(null);
	
		// Clear localStorage
		const cacheKeys = [
		  "cachedAddress",
		  "selectedVariant",
		  "drivers",
      	  "adddriver",
		  "tmim_add_ons",
		  "tmimQuoteAddOns",
		  "selectedE089Addon"
		];
		cacheKeys.forEach((key) => localStorage.removeItem(key));
	};

    useEffect(() => {
		fetchData();
	}, [getProfile]);

	const fetchData = async () => {
		if (token) {
			const response = await getProfile(token);
			if (response.success) {
				if (response.data.email) {
					setEmail(response?.data?.email);
				}
				if (response.data.phone_number) {
					setPhoneNo(response?.data?.phone_number);
				}
			}
		}
	};

	const getAddDrivers = (drivers) => {
		if (selectedPlan?.insurer_name === "GENERALI") {
			let id_data = {};
			if (
				(
					vehicleInfo?.id_type === "nric" || vehicleInfo?.id_type === "NRIC"
				) 
				&& vehicleInfo?.id_no
			) {
				try {
					id_data = getDOBFromId(vehicleInfo.id_no);
				} catch (err) {
					console.error("getDOBFromId failed:", err);
				}
			}

			// Filter out drivers with blank IC numbers
			const validDrivers = Array.isArray(drivers)
				? drivers.filter((driver) => driver.icnumber && driver.icnumber.trim() !== "")
				: [];

			// If no valid drivers, return policy holder as default
			if (validDrivers.length === 0) {
				return [
					{
						name: vehicleInfo?.owner_name || "THE POLICY HOLDER",
						icnumber: vehicleInfo?.id_no || "",
						drvdob: id_data?.dob || "",
						drvgender: id_data?.gender || "",
						drvrel: "INSD",
					},
				];
			}

			// Otherwise, return only the valid drivers
			return validDrivers;
		}
		return drivers
	}

	const getDrivers = (drivers) => {
		if (selectedPlan.insurer_name === 'ALLIANZ') {
			return allianzadddriver;
		}

		if (selectedPlan?.insurer_name !== "TOKIO MARINE") {
			if (
				!Array.isArray(drivers) ||
				drivers.length === 0 ||
				(Array.isArray(addOnSelection) &&
					addOnSelection.every((item) => !["ALD", "AND"].includes(item.code)))
			) {
				return [
					{ code: "01", name: vehicleInfo?.owner_name || "THE POLICY HOLDER" },
				];
			}

			if (drivers[0]?.code === "04") {
				return [{ code: "04", name: "ALL DRIVERS" }];
			} else {
				return [...drivers];
			}
		}

		if (
			selectedPlan?.insurer_name === "TOKIO MARINE" ||
			selectedPlan?.insurer_name === "TAKAFUL IKHLAS"
		) {
			return Array.isArray(drivers) ? drivers : [];
		}

		return Array.isArray(drivers) ? drivers : [];
	};

	const getDOBFromId = (idNo) => {
		const regex = /^(\d{6})\d{2}\d{3}(\d{1})$/;
		const match = idNo.match(regex);

		if (!match) {
			throw new Error("Invalid ID number format");
		}

		const birthDate = match[1];
		const genderDigit = parseInt(match[2], 10);

		const yearPrefix = birthDate.substring(0, 2);
		const month = birthDate.substring(2, 4);
		const day = birthDate.substring(4, 6);

		const currentYear = new Date().getFullYear();
		const currentCentury = Math.floor(currentYear / 100) * 100;

		let fullYear;

		if (parseInt(yearPrefix, 10) <= currentYear % 100) {
			fullYear = `20${yearPrefix}`;
		} else {
			fullYear = `19${yearPrefix}`;
		}

		const dob = new Date(`${fullYear}-${month}-${day}`);

		const age = currentYear - dob.getFullYear();

		if (isNaN(dob) || age < 0 || age > 120) {
			throw new Error("Invalid birth year in ID number");
		}

		const gender = genderDigit % 2 === 0 ? "F" : "M";

		const formattedDob = dob.toISOString().split("T")[0];

		return {
			dob: formattedDob,
			gender: gender,
			age: age,
		};
	};

	const proceedPayment = async (e) => {
		e.preventDefault();

		// [EMPTY-STATE GUARD] selectedPlan/vehicleInfo live only in (volatile) Redux + cache.
		// If they were cleared (a prior Confirm ran clearCacheAndState, or the WebView
		// reloaded / went back into this route), every field is blank and submitting would
		// POST an empty payload that /api/motor/store rejects with 400 "Validation failed"
		// (the "Package undefined … RM 0.00" screen). Bail out and prompt a re-quote instead.
		const isRenewal = !!new URLSearchParams(window.location.search).get("policy_id");
		const quoteLoaded = !!(selectedPlan?.insurer_name && selectedPlan?.total_payable);
		const vehicleLoaded = isRenewal || !!(vehicleInfo && vehicleInfo.reg_no);
		if (!quoteLoaded || !vehicleLoaded) {
			showErrorMessage("Your quote session has expired. Please go back and select your plan again.");
			return;
		}

		setLoading(true);
		try {
			let entryPayloads;
			let policyDetails;
			let policyData;
			let motorInsurance;

			const queryParameters = new URLSearchParams(window.location.search);
			const policyId = queryParameters.get("policy_id");

			if (policyId) {
				try {
					policyDetails = await viewPolicy(token, { id: policyId });
					policyData = policyDetails?.data || {};
					motorInsurance = policyData?.motor_insurance || {};
	
					let id_data;
					if ((motorInsurance.id_type === "nric" || motorInsurance.id_type === "NRIC") && motorInsurance.id_no) {
						id_data = getDOBFromId(motorInsurance.id_no);
					}
	
					const today = new Date(policyDetails?.policy_end_date || new Date());
					today.setHours(today.getHours() + 32);
	
					const inception_date = today.toISOString().split("T")[0];
					const expiry_date = new Date(today);
					expiry_date.setFullYear(expiry_date.getFullYear() + 1);
					expiry_date.setDate(expiry_date.getDate() - 1);
	
					entryPayloads = {
						auth_token: selectedPlan.auth_token,
						reference_data: selectedPlan.reference_data,
						reference_no: resolveQuoteRefNo(selectedPlan),
						premium_ref_no: selectedPlan.premium_ref_no,
						renewal_policy_no: selectedPlan.renewal_policy_no,
						quote_amount:
							selectedPlan.total_payable !== "" ? parseFloat(selectedPlan.total_payable) : 0.0,
						owner_name: motorInsurance?.owner_name,
						ownership_type: motorInsurance?.ownership_type,
						id_type: motorInsurance?.id_type,
						id_no: motorInsurance?.id_no,
						//marital_code: vehicleInfo?.marital_status,
						tin_number: selectedPlan?.tin_number || "",
						sst_number: selectedPlan?.sst_number || "",
						address_1: vehicleInfo?.address1,
						address_2: vehicleInfo?.address2,
						cover_note_type: "NWOO",
						veh_purch_price: selectedPlan.veh_purch_price !== "" ? selectedPlan.veh_purch_price : 0.0,
						effective_date: inception_date,
						expiry_date: expiry_date.toISOString().split("T")[0],
						vehicle: motorInsurance?.vehicle,
						postcode: motorInsurance?.postcode,
						veh_type: motorInsurance?.veh_type,
						make_code: motorInsurance?.make_code,
						model_code: motorInsurance?.model_code,
						capacity: motorInsurance?.capacity,
						seats: motorInsurance?.seats,
						variant_name: selectedVariant?.variant_name,
						variant_transmission: selectedVariant?.variant_transmission,
						engine_no: vehicleInfo.vehicle_details?.engine_no,
						chassis_no: vehicleInfo.vehicle_details?.chassis_no,
						nvic_code: selectedVariant?.variant_nvic,
						reg_no: motorInsurance.reg_no,
						make_year: motorInsurance?.make_year,
						min_market_value:
							motorInsurance?.sum_insured !== "" ? parseFloat(motorInsurance?.sum_insured) : 0.0,
						max_market_value:
							motorInsurance?.sum_insured !== "" ? parseFloat(motorInsurance?.sum_insured) : 0.0,
						insurer_name: motorInsurance?.insurer_name,
						insurer_plan: "Motor Premium",
						annual_premium:
							selectedPlan.annual_premium !== ""
								? parseFloat(selectedPlan.annual_premium)
								: 0.0,
						basic_premium:
							selectedPlan.basic_premium !== "" ? parseFloat(selectedPlan.basic_premium) : 0.0,
						net_premium:
							selectedPlan.net_premium !== "" ? parseFloat(selectedPlan.net_premium) : 0.0,
						act_premium:
							selectedPlan.act_premium !== "" ? parseFloat(selectedPlan.act_premium) : 0.0,
						discount_amount:
							selectedPlan.discount_amount !== ""
								? parseFloat(selectedPlan.discount_amount)
								: 0.0,
						discount_percent:
							selectedPlan.discount_percent !== ""
								? parseFloat(selectedPlan.discount_percent)
								: 0.0,
						commission_amount:
							selectedPlan.commission_amount !== ""
								? parseFloat(selectedPlan.commission_amount)
								: 0.0,
						commission_percent:
							selectedPlan.commission_percent !== ""
								? parseFloat(selectedPlan.commission_percent)
								: 0.0,
						excess_amount:
							selectedPlan.excess_amount !== "" ? parseFloat(selectedPlan.excess_amount) : 0.0,
						excess_percent:
							selectedPlan.excess_percent !== ""
								? parseFloat(selectedPlan.excess_percent)
								: 0.0,
						gross_premium:
							selectedPlan.gross_premium !== "" ? parseFloat(selectedPlan.gross_premium) : 0.0,
						gst_commission_amount:
							selectedPlan.gst_commission_amount !== ""
								? parseFloat(selectedPlan.gst_commission_amount)
								: 0.0,
						gst_commission_percent:
							selectedPlan.gst_commission_percent !== ""
								? parseFloat(selectedPlan.gst_commission_percent)
								: 0.0,
						gst_premium:
							selectedPlan.gst_premium !== "" ? parseFloat(selectedPlan.gst_premium) : 0.0,
						gst_percent:
							selectedPlan.gst_percent !== "" ? parseFloat(selectedPlan.gst_percent) : 0.0,
						ncd_amount:
							selectedPlan.ncd_amount !== "" ? parseFloat(selectedPlan.ncd_amount) : 0.0,
						ncd_percent:
							selectedPlan.ncd_percent !== "" ? parseFloat(selectedPlan.ncd_percent) : 0.0,
						sst_premium:
							selectedPlan.sst_premium !== "" ? parseFloat(selectedPlan.sst_premium) : 0.0,
						sst_percent:
							selectedPlan.sst_percent !== "" ? parseFloat(selectedPlan.sst_percent) : 0.0,
						stamp_duty:
							selectedPlan.stamp_duty !== ""
								? parseFloat(selectedPlan.stamp_duty)
								: 0.0,
						sum_insured: selectedPlan?.sum_insured ?
							motorInsurance?.sum_insured !== ""
								? parseFloat(motorInsurance?.sum_insured)
								: 0.0 : 0.0,
						total_extra_coverage_amount:
							selectedPlan.total_extra_coverage_amount !== ""
								? parseFloat(selectedPlan.total_extra_coverage_amount)
								: 0.0,
						total_payable:
							selectedPlan.total_payable !== "" ? parseFloat(selectedPlan.total_payable) : 0.0,
						total_loading_percent: selectedPlan.total_loading_percent !== "" ? selectedPlan.total_loading_percent : 0.0,
						total_loading_amount: selectedPlan.total_loading_amount !== "" ? selectedPlan.total_loading_amount : 0.0,
						veh_age_load_percent: selectedPlan.veh_age_load_percent !== "" ? selectedPlan.veh_age_load_percent : 0.0,
						veh_age_loading: selectedPlan.veh_age_loading !== "" ? selectedPlan.veh_age_loading : 0.0,
						ins_age_load_percent: selectedPlan.ins_age_load_percent !== "" ? selectedPlan.ins_age_load_percent : 0.0,
						ins_age_loading: selectedPlan.ins_age_loading !== "" ? selectedPlan.ins_age_loading : 0.0,
						claims_exp_load_percent: selectedPlan.claims_exp_load_percent !== "" ? selectedPlan.claims_exp_load_percent : 0.0,
						claims_exp_loading: selectedPlan.claims_exp_loading !== "" ? selectedPlan.claims_exp_loading : 0.0,
						max_cumulative_load_percent: selectedPlan.max_cumulative_load_percent !== "" ? selectedPlan.max_cumulative_load_percent : 0.0,
						max_cumulative_loading: selectedPlan.max_cumulative_loading !== "" ? selectedPlan.max_cumulative_loading : 0.0,
						quotes_extra_coverage: selectedPlan.extra_coverages || [],
						quotes_driver: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
						agree_value: selectedPlan?.agree_value || false,
						market_value: selectedPlan?.market_value || false
					};
				} catch (error) {
					console.error("Error fetching details:", error);
				}
			} else {
				entryPayloads = {
					auth_token: selectedPlan?.auth_token || "",
					reference_data: selectedPlan?.reference_data || "",
					reference_no: resolveQuoteRefNo(selectedPlan),
					premium_ref_no: selectedPlan?.premium_ref_no || "",
					quote_amount:
						selectedPlan.total_payable !== ""
							? parseFloat(selectedPlan.total_payable)
							: 0.0,
					owner_name: vehicleInfo?.owner_name || "",
					ownership_type: vehicleInfo?.ownership_type || "",
					id_type: vehicleInfo?.id_type || "",
					id_no: vehicleInfo?.id_no || "",
					//marital_code: vehicleInfo?.marital_status,
					tin_number: selectedPlan?.tin_number || "",
					sst_number: selectedPlan?.sst_number || "",
					address_1: vehicleInfo?.address1 || "",
					address_2: vehicleInfo?.address2 || "",
					cover_note_type: "NWOO",
					veh_purch_price:
						selectedPlan.veh_purch_price !== ""
							? selectedPlan.veh_purch_price
							: 0.0,
					effective_date: vehicleInfo?.effective_date || "",
					expiry_date: vehicleInfo?.expiry_date || "",
					vehicle: vehicleInfo?.vehicle || "",
					postcode: vehicleInfo?.postcode || "",
					veh_type: vehicleInfo?.veh_type || "",
					make_code: vehicleInfo?.vehicle_details?.make_code || "",
					model_code: vehicleInfo?.vehicle_details?.model_code || "",
					capacity: vehicleInfo?.vehicle_details?.veh_capacity || "",
					seats: selectedVariant?.variant_seat || "",
					variant_name: selectedVariant?.variant_name || "",
					variant_transmission: selectedVariant?.variant_transmission || "",
					engine_no: vehicleInfo.vehicle_details?.engine_no || "",
					chassis_no: vehicleInfo.vehicle_details?.chassis_no || "",
					nvic_code: selectedVariant?.variant_nvic || "",
					reg_no: vehicleInfo?.reg_no || "",
					make_year: vehicleInfo?.make_year || "",
					min_market_value:
						selectedPlan.sum_insured !== "" ? parseFloat(selectedPlan.sum_insured) : 0.0,
					max_market_value:
						selectedPlan.sum_insured !== "" ? parseFloat(selectedPlan.sum_insured) : 0.0,
					insurer_name: vehicleInfo?.insurer_name,
					insurer_plan: "Motor Premium",
					annual_premium:
						selectedPlan.annual_premium !== ""
							? parseFloat(selectedPlan.annual_premium)
							: 0.0,
					basic_premium:
						selectedPlan.basic_premium !== "" ? parseFloat(selectedPlan.basic_premium) : 0.0,
					net_premium:
						selectedPlan.net_premium !== "" ? parseFloat(selectedPlan.net_premium) : 0.0,
					act_premium:
						selectedPlan.act_premium !== "" ? parseFloat(selectedPlan.act_premium) : 0.0,
					discount_amount:
						selectedPlan.discount_amount !== ""
							? parseFloat(selectedPlan.discount_amount)
							: 0.0,
					discount_percent:
						selectedPlan.discount_percent !== ""
							? parseFloat(selectedPlan.discount_percent)
							: 0.0,
					commission_amount:
						selectedPlan.commission_amount !== ""
							? parseFloat(selectedPlan.commission_amount)
							: 0.0,
					commission_percent:
						selectedPlan.commission_percent !== ""
							? parseFloat(selectedPlan.commission_percent)
							: 0.0,
					excess_amount:
						selectedPlan.excess_amount !== "" ? parseFloat(selectedPlan.excess_amount) : 0.0,
					excess_percent:
						selectedPlan.excess_percent !== ""
							? parseFloat(selectedPlan.excess_percent)
							: 0.0,
					gross_premium:
						selectedPlan.gross_premium !== "" ? parseFloat(selectedPlan.gross_premium) : 0.0,
					gst_commission_amount:
						selectedPlan.gst_commission_amount !== ""
							? parseFloat(selectedPlan.gst_commission_amount)
							: 0.0,
					gst_commission_percent:
						selectedPlan.gst_commission_percent !== ""
							? parseFloat(selectedPlan.gst_commission_percent)
							: 0.0,
					gst_premium:
						selectedPlan.gst_premium !== "" ? parseFloat(selectedPlan.gst_premium) : 0.0,
					gst_percent:
						selectedPlan.gst_percent !== "" ? parseFloat(selectedPlan.gst_percent) : 0.0,
					ncd_amount:
						selectedPlan.ncd_amount !== "" ? parseFloat(selectedPlan.ncd_amount) : 0.0,
					ncd_percent:
						selectedPlan.ncd_percent !== "" ? parseFloat(selectedPlan.ncd_percent) : 0.0,
					sst_premium:
						selectedPlan.sst_premium !== "" ? parseFloat(selectedPlan.sst_premium) : 0.0,
					sst_percent:
						selectedPlan.sst_percent !== "" ? parseFloat(selectedPlan.sst_percent) : 0.0,
					stamp_duty:
						selectedPlan.stamp_duty !== "" ? parseFloat(selectedPlan.stamp_duty) : 0.0,
					sum_insured:
						selectedPlan.sum_insured !== "" ? parseFloat(selectedPlan.sum_insured) : 0.0,
					total_extra_coverage_amount:
						selectedPlan.total_extra_coverage_amount !== ""
							? parseFloat(selectedPlan.total_extra_coverage_amount)
							: 0.0,
					total_payable:
						selectedPlan.total_payable !== "" ? parseFloat(selectedPlan.total_payable) : 0.0,
					total_loading_percent: selectedPlan.total_loading_percent !== "" ? selectedPlan.total_loading_percent : 0.0,
					total_loading_amount: selectedPlan.total_loading_amount !== "" ? selectedPlan.total_loading_amount : 0.0,
					veh_age_load_percent: selectedPlan.veh_age_load_percent !== "" ? selectedPlan.veh_age_load_percent : 0.0,
					veh_age_loading: selectedPlan.veh_age_loading !== "" ? selectedPlan.veh_age_loading : 0.0,
					ins_age_load_percent: selectedPlan.ins_age_load_percent !== "" ? selectedPlan.ins_age_load_percent : 0.0,
					ins_age_loading: selectedPlan.ins_age_loading !== "" ? selectedPlan.ins_age_loading : 0.0,
					claims_exp_load_percent: selectedPlan.claims_exp_load_percent !== "" ? selectedPlan.claims_exp_load_percent : 0.0,
					claims_exp_loading: selectedPlan.claims_exp_loading !== "" ? selectedPlan.claims_exp_loading : 0.0,
					max_cumulative_load_percent: selectedPlan.max_cumulative_load_percent !== "" ? selectedPlan.max_cumulative_load_percent : 0.0,
					max_cumulative_loading: selectedPlan.max_cumulative_loading !== "" ? selectedPlan.max_cumulative_loading : 0.0,
					quotes_extra_coverage: selectedPlan.extra_coverages || [],
					quotes_driver: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
					agree_value: selectedPlan?.agree_value || false,
					market_value: selectedPlan?.market_value || false
				};
			}

			if (orderId) {
				const statusPayload = {
					orderId: orderId,
					status: "Closed",
				};

				console.log("Checkpoint 3 - updating old order:", statusPayload);

				try {
					const updateOldOrder = await updateOrderStatus(token, statusPayload);
					console.log("Checkpoint 3.1 - updateOldOrder result:", updateOldOrder);

					if (updateOldOrder && updateOldOrder.success) {
						localStorage.removeItem("order_id");
					} else {
						setLoading(false);
						showErrorMessage("Unable to update existing order status.");
						// stop further execution if update failed
						return;
					}
				} catch (err) {
					console.error("Error updating old order:", err);
					setLoading(false);
					return;
				}
			}

			// --- Extra coverage handling ---
			console.log("Checkpoint 4 - before insurer handling", entryPayloads);

			if (entryPayloads.insurer_name === "LONPAC") {
				if (!Array.isArray(entryPayloads.quotes_extra_coverage)) {
					entryPayloads.quotes_extra_coverage = [];
				}

				const unitDefault = [ "M01", "M11", "M68", "M63", "M65", "M66", "M67", "M03", "M17", "M02" ];

				entryPayloads = {
					...entryPayloads,
					quotes_extra_coverage: entryPayloads.quotes_extra_coverage.map(
						(coverage) => {
							if (coverage.code === "M51" && lonpacCart) {
								return {
									...coverage,
									description: lonpacCart.name ?? coverage.description,
									code: "M51",
									si: lonpacCart.si ?? "0",
									sum_insured: lonpacCart.si ?? "0",
									unit: lonpacCart.unit ?? "0",
								};
							}

							if (unitDefault.includes(coverage.code)) {
								return {
									...coverage,
									unit: "0.00"
								}
							}

							return {
								...coverage,
								description: coverage.description,
								code: coverage.code,
								sum_insured: coverage.sum_insured,
								amount: coverage.amount
							};
						}
					),
				};
				console.log(
					"Checkpoint 4.1 - after LONPAC handling",
					entryPayloads.quotes_extra_coverage
				);
			}

			if (entryPayloads.insurer_name === "RHBI") {
				if (!Array.isArray(entryPayloads.quotes_extra_coverage)) {
					entryPayloads.quotes_extra_coverage = [];
				}

				entryPayloads = {
					...entryPayloads,
					quotes_extra_coverage: entryPayloads.quotes_extra_coverage.map(
						(coverage) => {
							if (coverage.code === "E112" && lonpacCart) {
								return {
									...coverage,
									description:
										"ENDORSEMENT 112 - COMPENSATION FOR ASSESSED REPAIR TIME (CART)",
									code: "E112",
									sum_insured: lonpacCart.si ?? coverage.sum_insured,
									cart_days: lonpacCart.unit ?? coverage.cart_days,
									cart_amount: lonpacCart.amount ?? coverage.cart_amount,
								};
							}
							return coverage;
						}
					),
				};
				console.log(
					"Checkpoint 4.2 - after RHBI handling",
					entryPayloads.quotes_extra_coverage
				);
			}
			if (entryPayloads.insurer_name === "LONPAC") {
				entryPayloads ={
					...entryPayloads,
					quotes_extra_coverage: [...entryPayloads.quotes_extra_coverage.map((coverage)=> {
						if (coverage.code === "M51") {
							return {
								...coverage,
								description: lonpacCart.name,
								code: "M51",
								si: lonpacCart.si,
								unit: lonpacCart.unit
							}
						}
						return {
							...coverage,
							si: "0",
							unit: "1"
						};
					})],
				}
			}

			if (entryPayloads.insurer_name === "ETIQA") {
				entryPayloads = {
					...entryPayloads,
					quotes_extra_coverage: [...entryPayloads.quotes_extra_coverage.map((coverage)=> {
						console.log(coverage)
						if (coverage.code === "P07A") {
							return {
								...coverage,
								description: etiqaCart.name,
								code: etiqaCart.code,
								sum_insured: 0
							}
						}
						if (coverage.code === "P10A") {
							return {
								...coverage,
								description: etiqaLou.name,
								code: etiqaLou.code,
								sum_insured: 0
							}
						}
						if (coverage.code === "B089") {
							return {
								...coverage,
								sum_insured: parseFloat(localStorage.getItem("E089_sum_insured") || 0),
							}
						}
						if (coverage.code === "D027") {
							return {
								...coverage,
								sum_insured: parseFloat(JSON.parse(localStorage.getItem(`addon_${"D027"}_selection`)).sum_insured || 0)
							}
						}
						if (coverage.code === "D01A") {
							return {
								...coverage,
								description: etiqaD01A.name,
								code: etiqaD01A.code,
								sum_insured: 0
							}
						}
						return {
							...coverage,
						};
					})],
				}
			}

			console.log("Checkpoint 5 - final entryPayloads", entryPayloads);

			const createEntry = await createMotorEntry(token, entryPayloads);

			if (createEntry.success) {
				const entry_id = createEntry.data.motorInsId;
				
				if (entry_id) {
					const isRenewRoadTaxViaMyjpjExist = addOnSelection.find((addOn) => addOn.title === "RENEW ROAD TAX VIA MYJPJ");
					
					const today = new Date();
					today.setHours(today.getHours() + 8);

					const orderPayloads = {
						order_type: "quote",
						insurance_type: 5,
						enquiry_id: entry_id,
						mobile_number: vehicleInfo?.hphoneno || phone_no || "",
						full_name: vehicleInfo.owner_name
							? vehicleInfo.owner_name
							: vehicleInfo.companyName,
						insurance_plan: "Motor Premium",
						insurer_name: vehicleInfo?.insurer_name,
						order_status: "Pending Payment",
						order_date: today.toISOString().split("T")[0],
						order_value:
							selectedPlan.total_payable !== ""
								? selectedPlan.total_payable
								: 0.0,
						payment_status: "Pending",
						road_tax_renewal: isRenewRoadTaxViaMyjpjExist ? true : false,
					};

					const create_order = await createOrder(token, orderPayloads);

					if (create_order && create_order.success) {
						const orderNumber = create_order?.data?.orderNumber;
						// The backend picks the gateway (Ansa-Support#113); iPay88 runs as before.
						try {
							await startPaymentCheckoutOnce(orderNumber, {
								request: () => requestPaymentGateway(token, orderNumber),
								// The same hand-off step the iPay88 path takes before leaving.
								beforeLeave: () => clearCacheAndState(),
								payWithIpay88: async () => {
									const paymentResponse = await initiatePayment(token, orderNumber);
									if (paymentResponse) {
										// Create a container element to hold the HTML content
										const container = document.createElement("div");
										container.innerHTML = paymentResponse;
												
										// Append the container to the body
										document.body.appendChild(container);
										
										// Find the form and submit it
										const form = container.querySelector("#ipay88Form");
										if (form) {
											// [STATE-CLEAR] Clear the quote/vehicle cache only now, as we hand
											// off to the payment gateway — NOT in `finally` on every attempt
											// (which blanked the screen and caused the empty-payload 400).
											clearCacheAndState();
											form.submit();
										} else {
											setLoading(false);
											showErrorMessage("Unable to start payment. Please try again.");
										}
									} else {
										console.error("Failed to retrieve payment script.");
									}
								},
							});
						} catch (error) {
							if (!isGatewayCheckoutError(error)) throw error;
							// 409, 5xx, network or an untrusted answer: never fall back to iPay88.
							setLoading(false);
							showErrorMessage("Unable to start payment. Please try again.");
						}
					} else {
						setLoading(false);
						showErrorMessage("Unable to create order.");
					}
				} else {
					setLoading(false);
					showErrorMessage("Unable to fetch entry id.");
				}
			} else {
				setLoading(false);
				showErrorMessage(createEntry.message ? createEntry.message : "Unable to create entry.");
			}
		} catch (error) {
			setLoading(false);
			showErrorMessage("Something went wrong");
		}
	};

	const getAddOnDescription = (code) => {
		// Get the stored add-ons from localStorage
		let storedAddOns;
		let selectedAddOn;
		if (selectedPlan?.insurer_name == "TOKIO MARINE") {
			storedAddOns = JSON.parse(localStorage.getItem("tmim_add_ons")) || [];

			const matched = storedAddOns.find(addOn => addOn.code === code);
			return matched?.description || matched?.code;
		} else {
			selectedAddOn =
				JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
			storedAddOns = selectedAddOn.map((addon) => ({
				add_on_code: addon.code || "",
				add_on_name: addon.title || "",
				add_on_description: addon.description || "",
			}));
		}
		// Find the add-on with the matching code
		const matched = storedAddOns.find(addOn => addOn.add_on_code.trim() === code.trim());
	  
		// Return the description if found, otherwise return the code
		return matched?.add_on_name || matched?.add_on_description;
	};

	function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);
		  
		if (isNaN(date)) return ""; // handle invalid date
		  
		const day = String(date.getDate()).padStart(2, "0");
	  
		const months = [
			"JAN", 
			"FEB", 
			"MAR", 
			"APR", 
			"MAY", 
			"JUN", 
			"JUL", 
			"AUG", 
			"SEP", 
			"OCT", 
			"NOV", 
			"DEC"
		];
		
		const month = months[date.getMonth()];
		const year = date.getFullYear();
	  
		return `${day}-${month}-${year}`;
	}

	if (loading) {
		return (
			<div className="content">
				<div className="get-quote-process-container">
					<div className="d-flex w-100"></div>
					<div className="text-center py-4">
						<i className="pi pi-spinner pi-spin"></i>
					</div>
				</div>
			</div>
		);
	}

	if (!selectedPlan?.insurer_name) {
		// [EMPTY-STATE GUARD] Without a loaded quote the summary would render
		// "Package undefined … RM 0.00" and a Confirm would 400. Show a recovery
		// prompt instead of the blank summary.
		return (
			<div className="content">
				<div className="get-quote-process-container">
					<div className="d-flex w-100 flex-column text-center py-4">
						<h3>Payment Summary</h3>
						<p className="formatted-text mt-2">
							Your quote session has expired. Please go back and select your plan again.
						</p>
						<Button
							label="Back"
							className="btn-primary mt-3"
							onClick={() => navigate(-1)}
						/>
					</div>
				</div>
			</div>
		);
	}

	return (
		<>
			<div className="content">
				<div className="get-quote-container d-m-column">
					<div className="d-flex w-100">
						<h3>Payment Summary</h3>
						<div className="car-details-block border-radius-25 p-20">
							<div className="grid">
								<div className="col-lg-6 text-left px-20">
									<h4 className="my-2 mt-4">
										{`${selectedPlan.insurer_name === "ETIQA" ? t( `autoInsurance.payment.product`) : t( `autoInsurance.payment.package`)} 
										${getInsurerName(selectedPlan.insurer_name)} - 1 ${t( `common.year`)}`}
									</h4>
									<hr
										style={{
											border: "1px solid #555",
											backgroundColor: "#555",
										}}
									/>
									{/* TIMB NDDP item 1 (Ansa-Support#30): the underwriter's legal name,
										company number and the distributor relationship, repeated here on the
										final confirmation page rather than only on the plan card. */}
									{selectedPlan?.insurer_name === "TUNE PROTECT" && (
										<UnderwriterDisclosure insurerName={selectedPlan.insurer_name} />
									)}
									{selectedPlan?.insurer_name === "TUNE PROTECT" &&
										<div className="d-flex justify-content-between align-items-center pb-2">
											<div className="vw-50 text-left">
												<span className="formatted-text">
													{vehicleInfo?.veh_type === "car" ? 'Tune Motor Easy' : 'Tune Bike Easy'}
												</span>
											</div>
										</div>
									}
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
											<span className="formatted-text">{"Protection Type"}</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{`Comprehensive`}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="w-50text-left">
											<span className="formatted-text">
												{"Coverage Period"}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{`${
													formatDate(vehicleInfo?.effective_date)
												} - ${
													formatDate(vehicleInfo?.expiry_date)
												}`}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="w-50text-left">
											<span className="formatted-text">{"Total Coverage"}</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat(
													"en-US",
													{
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}
												).format(
													selectedPlan?.sum_insured || 0
												)}`}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="w-50text-left">
											<span className="formatted-text">
												{t(`autoInsurance.addOns.basicPremium`)}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat(
													"en-US",
													{
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}
												).format(
													selectedPlan?.basic_premium || 0
												)}`}
											</span>
										</div>
									</div>

									{Number(selectedPlan?.all_rider_amount) > 0 && (
										<div className="d-flex justify-content-between align-items-center pb-2">
											<div className="vw-50 text-left">
												<span className="formatted-text">
													{
														"All Rider Premium"
													}
												</span>
											</div>
											<div className="vw-50 text-right">
												<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
													"en-US",
													{
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}
												).format(
													Number(
														selectedPlan?.all_rider_amount
													) || 0
												)}`}
												</span>
											</div>
										</div>
									)}

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="w-50text-left">
											<span className="formatted-text">{`No Claim Discount (${parseFloat(selectedPlan?.ncd_percent || 0)}%)`}</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{`- RM ${new Intl.NumberFormat(
													"en-US",
													{
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}
												).format(
													selectedPlan?.ncd_amount || 0
												)}`}
											</span>
										</div>
									</div>

									{/* TIMB NDDP item 3 (Ansa-Support#30): the breakdown on the final
										confirmation page must carry the gross premium. It was shown for Etiqa
										only; the package page has always shown it for everyone, so this row
										is no longer gated on the insurer. */}
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="w-50text-left">
											<span className="formatted-text">Gross Premium</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.gross_premium || 0)}`}
											</span>
										</div>
									</div>
								</div>

								{selectedPlan.extra_coverages && selectedPlan.extra_coverages.length > 0 && (
									<div className="col-lg-6 text-left px-20">
										<h4 className="my-2 mt-4">Add-Ons</h4>
										<hr style={{ border: '1px solid #555', backgroundColor: '#555' }} />
										{selectedPlan.extra_coverages.map((add_ons, index) => (
											<div className="d-flex justify-content-between align-items-start pb-2">
												<div className="vw-50 col-sm-6 text-left">
													<span className="formatted-text">{add_ons.description ? add_ons.description : getAddOnDescription(add_ons.code)}</span>
												</div>
												
												{(add_ons.amount && add_ons.amount != 0) ? (<>
													<div
													className={`vw-50 ${
														add_ons.amount
														? "col-sm-6"
														: ""
													} text-right`}
													>
														<span className="fw-medium color-heading">
															{add_ons.amount
															? `RM ${new Intl.NumberFormat(
																"en-US",
																{
																	minimumFractionDigits: 2,
																	maximumFractionDigits: 2,
																}
																).format(
																	add_ons.amount ||
																	0
																)}`
															: ""}
														</span>
													</div>
												</>)
												:
												(<>
													<div
													className={`vw-50 ${
														add_ons.sum_insured
														? "col-sm-6"
														: ""
													} text-right`}
													>
														<span className="fw-medium color-heading">
															{add_ons.sum_insured
															? `RM ${new Intl.NumberFormat(
																"en-US",
																{
																	minimumFractionDigits: 2,
																	maximumFractionDigits: 2,
																}
																).format(
																	add_ons.sum_insured ||
																	0
																)}`
															: ""}
														</span>
													</div>
												</>)}
											</div>
										))}

										<hr style={{ border: '1px solid #555', backgroundColor: '#555' }} />

										<div className="col-lg-6 text-left">
											<div className="d-flex justify-content-between align-items-center pb-2">
												<div className="vw-50 text-left">
													<span
														className="fw-bold color-heading"
														style={{ fontSize: '0.9rem' }} 
													>{"Total Premium"}
													</span>
													<div className="vw-50 text-right">
														<span
															className="fw-bold color-heading"
															style={{ fontSize: '0.9rem' }} 
														>{`RM ${new Intl.NumberFormat(
															"en-US",
															{
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															}
														).format(
															selectedPlan?.gross_premium || 0
														)}`}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}

								

								<div className="col-lg-6 text-left px-20">
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className={`vw-50 text-left`}>
											<span className="formatted-text">
												{`Service Tax (${parseFloat(selectedPlan?.sst_percent || 0)}%)`}
											</span>
										</div>
										<div className={`vw-50 text-right`}>
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.sst_premium || 0)}`}
											</span>
										</div>
									</div>
								</div>

								<div className="col-lg-6 text-left px-20">
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className={`vw-50 text-left`}>
											<span className="formatted-text">{`Stamp Duty`}</span>
										</div>
										<div className={`vw-50 text-right`}>
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.stamp_duty || 0)}`}
											</span>
										</div>
									</div>
								</div>

								{/* Add the HR element here */}
								<hr style={{ border: '1px solid #555', backgroundColor: '#555', width: 'calc(100% - 40px)' }} />

								{selectedPlan.insurer_name !== "ETIQA" && (
									<div className="col-lg-6 text-left px-20">
										<div className="d-flex justify-content-between align-items-center pb-2">
											<div className={`vw-50 text-left`}>
												<span className="fw-bold color-heading">
													{"Sub-Total"}
												</span>
											</div>
											<div className={`vw-50 text-right`}>
												<span className="fw-medium color-heading">
													{`RM ${new Intl.NumberFormat("en-US", {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}).format(
														Number(selectedPlan?.sst_premium || 0) +
															Number(selectedPlan?.stamp_duty || 0)
													)}`}
												</span>
											</div>
										</div>
									</div>
								)}

								<div
									className="col-lg-6 text-left px-20"
									// style={{ marginBottom: '35px' }}
								>
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
										<span
											className="fw-bold color-heading"
											style={{ fontSize: '1.1rem' }} 
										>
												{"Total Payable Amount"}
											</span>
										</div>
										<div className="vw-50 text-right">
										<span
											className="fw-bold color-heading"
											style={{ fontSize: '1.1rem' }}
										>{`RM ${new Intl.NumberFormat(
												"en-US",
												{
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
										  		}
											).format(selectedPlan?.total_payable || 0
										  	)}`}</span>
										</div>
									</div>
								</div>
								<div className="col-lg-6 text-left mt-2 px-20">
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="text-left" style={{ width: "50%" }}>
											<span className="formatted-text">
												{`Intermediaries’ Commission (${parseFloat(
													selectedPlan?.commission_percent || 0
												)}%)`}
											</span>
										</div>
										<div className="text-right" style={{ width: "50%" }}>
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.commission_amount || 0)}`}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* TIMB NDDP item 2 (Ansa-Support#30): the commission-rebate statement has
							to be read BEFORE the final confirmation of purchase, so it sits directly
							above Confirm — the last control before the payment gateway. */}
						{selectedPlan?.insurer_name === "TUNE PROTECT" && (
							<CommissionRebateNotice insurerName={selectedPlan.insurer_name} />
						)}
						<Button
							label="Confirm"
							className="btn-primary mt-4"
							loading={loading}
							onClick={(e) => proceedPayment(e)}
						/>
					</div>
				</div>
				{/* <div className="btn-primary mt-4">
					<Button
						label="Confirm"
						className="btn-primary"
						loading={loading}
						onClick={(e) => proceedPayment(e)}
					/>
				</div> */}
				{/* BottomMessagePopUp Component */}
				<BottomMessagePopUp
					message={errorMessage}
					type="error"
					isVisible={isErrorVisible}
					onClose={() => setIsErrorVisible(false)}
				/>
			</div>
		</>
	);
};

export default MotorPaymentPage;
